import { getLocation } from 'connected-react-router';
import { createSelector } from 'reselect';
import { getIsViewingToggled } from '../../../../common/engine/reducers/calcEngine';
import { structuredRoutes } from '../../../../common/services/urlService';

const getIsCurrentRouteAStructuredAnalysisRoute = createSelector(
  getLocation,
  (currentLocation) => {
    return (
      Object.keys(structuredRoutes).filter((key) => {
        const currentKeyPath = structuredRoutes[key];
        return currentLocation.pathname.endsWith(currentKeyPath);
      }).length > 0
    );
  }
);

export const getAppBannerConfig = createSelector(
  getIsViewingToggled,
  getIsCurrentRouteAStructuredAnalysisRoute,
  (isViewingToggled, isStructuredAnalysisLocation) => {
    return {
      showBanner: isViewingToggled && isStructuredAnalysisLocation,
    };
  }
);
